<header>
  <se-fe-page [seFeDataBackLink]="backLink" [seFeDataBackQueryParams]="backLinkQueryParams"
    seFeDataBackText="{{ !showMainHeader ? (backLinkTranslationKey | translate) : '' }}" [seFeDataLoaded]="dataLoaded"
    SeFeDataWidth="full">
    <div seFePageHeader>
      <ng-container *ngTemplateOutlet="showMainHeader ? mainHeader : header"> </ng-container>
      <ng-template #mainHeader>
        <se-fe-header seFePageHeader size="750">
          <div seFeHeaderTitle class="header-top">Financial Reports</div>
          @if (dataLoaded) {
          <ng-container seFeHeaderSubtitle>
            {{ reportsHeaderSubtitle }}
            <a [href]="financialSettingsUrl()" class="pl-link" target="_top"> Edit </a>
          </ng-container>
          }
          <div seFeHeaderActions>
            <a seFeLink class="legacyReportLink" (click)="legacyReports()"> View Legacy Reports </a>
          </div>
        </se-fe-header>
      </ng-template>
    </div>

    @if (dataLoaded && showMainHeader) {
    <div seFePageTabs>
      <se-fe-tabs class="se-fe-page-tabs" seFePageTabs [seFeDataTabs]="reportTabs" [seFeDataTabPanel]="reportTabPanel">
      </se-fe-tabs>
    </div>
    }

    <se-fe-tab-panel #reportTabPanel seFePageContent>
      <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate($event)"></router-outlet>
    </se-fe-tab-panel>
  </se-fe-page>
</header>
